import { z } from "zod";

export const mapFeatureValueSchema = z.object({
  geographyCode: z.string().min(1),
  value: z.number().nullable(),
  isSuppressed: z.boolean(),
  qualityFlag: z.string().nullable(),
});

const nonnegativeCount = z.number().int().nonnegative();
const missingGeography = z.object({
  geographyCode: z.string().min(1),
  name: z.string(),
});

export const coverageSchema = z.object({
  totalGeographies: nonnegativeCount,
  coveredGeographies: nonnegativeCount,
  missingGeographies: z.array(missingGeography),
});

export const mapSliceSchema = z.object({
  datasetReleaseId: z.string().min(1),
  boundaryVersionId: z.string().min(1),
  metricId: z.string().min(1),
  statisticId: z.string().min(1),
  period: z.string().min(1),
  sourceLabel: z.string().min(1),
  sourceUrl: z.string(),
  values: z.array(mapFeatureValueSchema),
  coverage: coverageSchema,
});

const baselinePeriodSchema = z.string().nullable();
export const mapChangeSchema = mapSliceSchema.extend({
  baselinePeriod: baselinePeriodSchema,
});

export const mapPeriodsSchema = z.object({
  metricId: z.string().min(1),
  statisticId: z.string().min(1),
  geographyLevel: z.string().min(1),
  periods: z.array(z.string().min(1)),
});

const timeSeriesPoint = z.object({
  period: z.string().min(1),
  value: z.number().nullable(),
});

const regionSeries = z.object({
  geographyCode: z.string().min(1),
  points: z.array(timeSeriesPoint),
});

export const regionTimeSeriesSchema = z.object({
  metricId: z.string().min(1),
  statisticId: z.string().min(1),
  geographyLevel: z.string().min(1),
  series: z.array(regionSeries),
});

export const timeSeriesPointSchema = timeSeriesPoint;

export type MapFeatureValue = z.infer<typeof mapFeatureValueSchema>;
export type MapSlice = z.infer<typeof mapSliceSchema>;
export type MapSliceCoverage = z.infer<typeof coverageSchema>;
export type MapChange = z.infer<typeof mapChangeSchema>;
export type MapPeriods = z.infer<typeof mapPeriodsSchema>;
export type TimeSeriesPoint = z.infer<typeof timeSeriesPointSchema>;
export type RegionTimeSeries = z.infer<typeof regionTimeSeriesSchema>;

export type MapSliceRequest = {
  metricId: string;
  geographyLevel: string;
  statisticId: string;
  period: string;
  refresh?: boolean;
};

export type MapPeriodsRequest = {
  metricId: string;
  geographyLevel: string;
  statisticId: string;
  refresh?: boolean;
};

export type MapChangeRequest = {
  metricId: string;
  geographyLevel: string;
  statisticId: string;
  period: string;
  baseline: "previous" | "yearly";
  refresh?: boolean;
};

export type RegionTimeSeriesRequest = {
  metricId: string;
  geographyLevel: string;
  statisticId: string;
  geographyCodes: string[];
};
